/**
 * The reason a request was refused, preferring the backend's own words.
 *
 * Several of our POST routes answer a refusal with a JSON body that names the
 * actual rule rather than a status class. The reference-input validator is the
 * sharpest example — both `POST /media/generate` and `POST /media/:id/regenerate`
 * answer 422 with
 *
 *     {"error": "veo-3.1 does not accept reference images together with a
 *                first frame", "code": "reference_inputs_invalid"}
 *
 * (`internal/api/media/referenceInputs.go:48-57`, reached from
 * `regenerateMedia.go:138`). An axios error's `.message` for that response is
 * "Request failed with status code 422", which tells the operator nothing they
 * can act on, so the body's sentence is shown verbatim wherever we have one.
 *
 * Lives in `api/` rather than in one of the two surfaces because the Generate
 * tab and the regenerate surfaces hit the SAME contract, and a copy in each is
 * how one of them ends up rendering the status line again.
 */
export const readRequestError = (error: unknown, fallback: string): string => {
  const message = (error as { response?: { data?: { error?: unknown } } })?.response?.data?.error;
  if (typeof message === 'string' && message.trim()) return message.trim();
  return fallback;
};
